import RandomGenerator from "./RandomGenerator";

class TickerGenerator {

    private readonly generator: RandomGenerator;

    public constructor(seed: string) {
        this.generator = new RandomGenerator(seed);
    }

    /**
     * Get the next ticker price
     * @param previous      Previous ticker price
     * @param volatility    Current volatility - between 0 and 1
     */
    public next(previous: number, volatility: number): number {

        const random = this.generator.next();
        let change = 2 * volatility * random;
        if (change > volatility) change -= 2 * volatility;
        const amount = previous * change;
        return previous + amount;

    }

}

export default TickerGenerator;